import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "page-content"
}

export function render(_ctx, _cache) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")
  const _component_ContactPostQualificationForm = _resolveComponent("ContactPostQualificationForm")

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isDataLoading)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          absolute: ""
        }))
      : (_ctx.token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "mb-4" }, "Please complete your data", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("p", null, " So that we can clearly assign your request for careful processing, we ask you to complete the following data. ", -1)),
            (_ctx.postQualification)
              ? (_openBlock(), _createBlock(_component_ContactPostQualificationForm, {
                  key: 0,
                  postQualification: _ctx.postQualification,
                  onSubmit: _ctx.submit,
                  isSubmitting: _ctx.isSubmitting
                }, null, 8, ["postQualification", "onSubmit", "isSubmitting"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
  ]))
}